export default __webpack_public_path__ + "static/media/etapa3.fa781dec.png";